<template>
  <div class="footNote">
    <p>
      <span> 公司名称：海南玄鸟信息技术有限公司 </span>
    </p>
   <p>
      <span> 公司地址：海南省澄迈县老城镇高新技术产业示范区海南生态软件园A25幢四层106号</span>
    </p> 
  <p>
      <span> 联系电话：18779117562</span>
    </p>
    <!-- <p class="friendly-link">友情链接: <a v-for="link in friendlyLink" :href="link.website">{{link.name}}</a>&nbsp;&nbsp;
      <a href="https://www.ailoli.org/">Ailoli</a>&nbsp;&nbsp;
      <a href="https://aoaoao.me/">树洞</a>
    </p> -->

<!--    <p>
      <a href="https://beian.miit.gov.cn/" target="_blank"
        style="font-size: 15px; color: aliceblue;">琼ICP备2023002567号</a>
    </p> -->
  </div>
</template>

<script>
  export default {
    name: 'blogFoot',
    data() {
      return {
        friendlyLink: [{
          name: 'Vue.js',
          website: 'https://cn.vuejs.org/'
        }, {
          name: 'Ailoli',
          website: 'https://www.ailoli.org/'
        }, {
          name: '树洞',
          website: 'https://aoaoao.me/'
        }]
      }
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .footNote {
    background-color: black;
  }
  
  .footNote p{
     font-size: 13px !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/components/blog-foot.vue